import React from 'react';

export const IndividualStakeholderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
  >
    <rect x="0.5" y="1" width="21" height="21" rx="7.5" fill="white" />
    <path
      d="M14.0415 12.5141C14.6984 12.5141 15.2308 13.0253 15.2308 13.656V14.1224C15.2308 14.4136 15.1361 14.6974 14.9597 14.9343C14.1422 16.0327 12.8072 16.5769 10.9983 16.5769C9.1891 16.5769 7.8548 16.0325 7.0392 14.9335C6.86364 14.6969 6.76929 14.4137 6.76929 14.1232V13.656C6.76929 13.0253 7.30177 12.5141 7.95863 12.5141H14.0415ZM10.9983 6.42307C12.4587 6.42307 13.6426 7.55978 13.6426 8.96198C13.6426 10.3642 12.4587 11.5009 10.9983 11.5009C9.5379 11.5009 8.354 10.3642 8.354 8.96198C8.354 7.55978 9.5379 6.42307 10.9983 6.42307Z"
      fill="#27B0E0"
    />
    <rect x="0.5" y="1" width="21" height="21" rx="7.5" stroke="#27B0E0" />
  </svg>
);
